export const STATUS_QUEUE = [1, 0, 2, 3];

export const VIEW_MODE = {
  GRID: "grid",
  LIST: "list",
};

export const TAB_VARIANTS = {
  OUTLINED: "outlined",
  FILLED_PRIMARY: "filled_primary",
};

export const QUERY_KEYS = {
  LISTINGS: "listings",
  DRAFT_LISTINGS: "listings-draft",
  WAITLIST_LISTINGS: "listings-waitlist",
  PAST_LISTINGS: "listings-past",
  RECENT_LISTINGS: "listings-recent",
  PLANS: "plans",
  FILTERED: "filtered",
};

/** Listing type (numeric) used to select the matching My Offerings tab after create. */
export const CREATED_LISTING_TYPE_KEY = "scheduleListCreatedListingType";

export const PUBLISHED_LISTING_TYPE_QUERY_KEY = "published_listing_type";

export const API_URLS = {
  LISTINGS: "host/listing/paginated/list",
  PLANS_DROPDOWN: "host/list/dropdown/plan",
};

export const TYPE_LABEL_FALLBACK_PREFIX = "Type ";
